/* tslint:disable */
/* eslint-disable */
/**
 * Local Map - Local Map Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.3
 * Contact: local-map@daangn.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../runtime';
import type { V1SearchResultExpertReservationLocalProfile } from './V1SearchResultExpertReservationLocalProfile';
import {
    V1SearchResultExpertReservationLocalProfileFromJSON,
    V1SearchResultExpertReservationLocalProfileFromJSONTyped,
    V1SearchResultExpertReservationLocalProfileToJSON,
} from './V1SearchResultExpertReservationLocalProfile';

/**
 * 
 * @export
 * @interface V1SearchResultExpertReservation
 */
export interface V1SearchResultExpertReservation {
    /**
     * 
     * @type {Array<V1SearchResultExpertReservationLocalProfile>}
     * @memberof V1SearchResultExpertReservation
     */
    localProfiles: Array<V1SearchResultExpertReservationLocalProfile>;
}

/**
 * Check if a given object implements the V1SearchResultExpertReservation interface.
 */
export function instanceOfV1SearchResultExpertReservation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "localProfiles" in value;

    return isInstance;
}

export function V1SearchResultExpertReservationFromJSON(json: any): V1SearchResultExpertReservation {
    return V1SearchResultExpertReservationFromJSONTyped(json, false);
}

export function V1SearchResultExpertReservationFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1SearchResultExpertReservation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'localProfiles': ((json['local_profiles'] as Array<any>).map(V1SearchResultExpertReservationLocalProfileFromJSON)),
    };
}

export function V1SearchResultExpertReservationToJSON(value?: V1SearchResultExpertReservation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'local_profiles': ((value.localProfiles as Array<any>).map(V1SearchResultExpertReservationLocalProfileToJSON)),
    };
}

